
const MODAL_TRANSITION = {
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    }
}
export default MODAL_TRANSITION